import { render, staticRenderFns } from "./IconsPagesSettings.vue?vue&type=template&id=d7927f76&scoped=true&"
import script from "./IconsPagesSettings.vue?vue&type=script&lang=js&"
export * from "./IconsPagesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7927f76",
  null
  
)

export default component.exports